var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { staticClass: "publication-container", attrs: { "md-flex": "100" } },
    [
      _c(
        "md-layout",
        { staticClass: "date-container", attrs: { "md-flex": "85" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
          _c(
            "md-input-container",
            {
              class: {
                "md-input-invalid": _vm.formSubmitted && _vm.validation.$invalid
              }
            },
            [
              _c("md-input", {
                attrs: {
                  placeholder: "Ex: 09-16-2024",
                  type: "datetime-local"
                },
                on: { change: _vm.onDateTimeChange },
                model: {
                  value: _vm.dateTime,
                  callback: function($$v) {
                    _vm.dateTime = $$v
                  },
                  expression: "dateTime"
                }
              }),
              _vm.formSubmitted && !_vm.validation.validDate
                ? _c("span", { staticClass: "md-error" }, [
                    _vm._v("Invalid date format")
                  ])
                : _vm._e(),
              _vm.formSubmitted && !_vm.validation.isFutureDate
                ? _c("span", { staticClass: "md-error" }, [
                    _vm._v("Date must be later than today")
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "md-layout",
        { attrs: { "md-flex": "10" } },
        [
          _c(
            "md-button",
            {
              staticClass: "md-icon-button",
              attrs: { id: "btnCleanDate" },
              on: { click: _vm.cleanDate }
            },
            [_c("md-icon", { attrs: { "md-iconset": "fa fa-eraser" } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5966858f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5966858f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/DateInputTime.vue
// module id = 964
// module chunks = 0